import { formsConstants } from '@constants/forms';
import { formsService } from '@services';

export const formsActions = {
    getAll,
};

function getAll() {
    return dispatch => {
        dispatch(request());

        return formsService.getAll().then(
            forms => dispatch(success(forms)),
            error => dispatch(failure(error.toString())),
        );
    };

    function request() {
        return { type: formsConstants.FORMS_REQUEST };
    }
    function success(forms) {
        return { type: formsConstants.FORMS_SUCCESS, forms };
    }
    function failure(error) {
        return { type: formsConstants.FORMS_ERROR, error };
    }
}
